<div
  class="component-container h-full overflow-auto"
  (scrolled)="getNext()"
  [alwaysCallback]="true"
  [infiniteScrollDistance]="scrollDistance"
  [infiniteScrollThrottle]="throttle"
  [scrollWindow]="false"
  infinite-scroll
>
  <app-behaviour-tracker-detail-screen-shimmer-loader
    *ngIf="weekSummaryLoader;else weekDetails"
  ></app-behaviour-tracker-detail-screen-shimmer-loader>
  <ng-template #weekDetails>
    <div
      class="week-details-container p-[2.5rem]"
    >
      <div
        class="header w-full flex flex-row justify-between items-center flex-wrap gap-[2rem]"
      >
        <div class="details-section flex flex-row justify-center items-center gap-[0.7rem]">
          <app-icon
            class="calender-icon"
            svgIcon="calender"
          >
          </app-icon>
          <div class="week-info-section flex flex-col gap-[0.8rem]">
            <div
              class="row flex flex-row justify-start items-center gap-[0.8rem] flex-wrap"
            >
              <div class="week-number">
                Week {{ weekNumber }}
              </div>
              <div
                *ngFor="let session of weekSummary['sessionData']"
                class="session-info"
              >
                <div class="pill-container flex flex-row justify-center items-center gap-[1rem]">
              <span class="session-number">
                S{{ session?.sessionNumber| number: '2.0-0' }}
              </span>
                  <span class="session-start-date">
                {{ session?.sessionDate | date: 'MMM dd' }}
              </span>
                </div>

              </div>
            </div>
            <div class="row flex flex-row justify-start items-center">
          <span class="week-date-details">
            {{ weekSummary['startDate'] | date:'mediumDate' }}
            - {{ weekSummary['endDate'] | date:'mediumDate' }}
          </span>
            </div>
          </div>
        </div>
        <div class="action-section self-place-center">
          <app-primary-button
            (handleClick)="redirectToContracts()"
            *ngIf="displayContractBtn && weekSummary['lastSessionInWeek'] >= 4"
            class="goals-and-contracts w-[30rem]"
            type="small"
          >
            <div class="btn-content flex flex-row justify-center items-center gap-[1rem]">
              <app-icon
                [svgIcon]="weekSummary['signedOn'] ? 'contract-met':'contract-not-met'"
                class="{{weekSummary['signedOn'] ? 'contract-met-icon':'contract-not-met-icon'}} {{ weekSummary['createdAt'] ? '' : 'contract-not-saved-icon' }}"
              ></app-icon>
              <span> Weekly Goals & Contract</span>
            </div>
          </app-primary-button>
        </div>
      </div>
      <hr class="hr">
      <div
        *ngIf="showDetailsForAdult || weekSummary['lastSessionInWeek'] >= 2"
        class="weekly-summary-section"
      >
        <mat-expansion-panel
          [expanded]="true"
          class="mat-elevation-z0 expansion-panel w-full"
        >
          <mat-expansion-panel-header class="flex flex-row justify-center items-center">
            <div class="title">
              Weekly Summary
            </div>
          </mat-expansion-panel-header>
          <div
            class="chart-container-panel flex w-full flex-col lg:flex-row flex-wrap gap-[2.8rem] p-[2rem] justify-between"
          >
            <div
              *ngIf="showDetailsForAdult || (weekSummary['lastSessionInWeek']
               >= 2 && selectedDateDetails['lastSession'] >= 2)"
              class="chart-container flex
            flex-col justify-center items-center"
            >
              <div
                class="flex flex-row
              justify-center items-center
              gap-[1rem]"
              >
                <app-icon
                  class="red-light-icon"
                  svgIcon="red-light"
                >
                </app-icon>
                <span class="heading">My Red Light Foods</span>
                <app-icon
                  [matTooltip]="'Lighter colored bars are estimated using the highest value from that week.'"
                  class="info-icon ml-[1rem]"
                  matTooltipClass="custom-tooltip"
                  matTooltipPosition="above"
                  svgIcon="info"
                />
              </div>
              <app-red-light-chart
                [data]="weekSummary['weekData']"
                class="red-light-chart w-full"
              >
              </app-red-light-chart>
              <div
                class="summary flex flex-col justify-center items-center mt-[3.2rem]"
              >
                <div
                  *ngIf="!showDetailsForAdult&&showDetailsForAdult ||
                (weekSummary['lastSessionInWeek'] >= 4 &&
                selectedDateDetails['lastSession'] >= 4)"
                >Weekly
                 goal: <span class="score">{{ weeklyRlGoal || '_' }}</span> or
                 less,
                </div>
                <div>
                  You ate <span
                  class="score"
                >{{ weeklyRlPointSum !== null ? weeklyRlPointSum : '_' }}</span> this
                  week
                </div>
              </div>
              <span
                (click)="viewProgress('rl')"
                class="view-progress underline
              text-[1.4rem] font-work-sans
              font-normal text-digital-blue-light
              cursor-pointer mt-[2.4rem]"
              >
        View Progress
      </span>
            </div>
            <div
              *ngIf="showDetailsForAdult || (weekSummary['lastSessionInWeek']
               >= 8 && selectedDateDetails['lastSession'] >= 8)"
              class="chart-container flex
            flex-col justify-center items-center"
            >
              <div
                class="heading flex flex-row
              justify-center items-center
              space-x-[1rem]"
              >
                <app-icon
                  class="physical-activity-icon"
                  svgIcon="physical-activity"
                >
                </app-icon>
                <span class="font-bold font-poppins text-[2rem] text-cool-grey">My Physical Activity</span>
              </div>
              <app-physical-activity-chart
                [data]="weekSummary['weekData']"
                class="physical-activity-chart w-full"
              >
              </app-physical-activity-chart>
              <div
                class="font-semibold font-work-sans text-[1.5rem] text-cool-grey flex flex-col justify-center items-center mt-[3.2rem]"
              >
                <ng-container *ngIf="!showDetailsForAdult">
                  <ng-container
                    *ngIf="showDetailsForAdult || (weekSummary['lastSessionInWeek'] > 8 &&
                  selectedDateDetails['lastSession'] > 8)"
                  >
                    <div>
                      Weekly goal: <span class="text-palo-verde text-[2rem]">{{
                        weeklyPaGoalDays || '_'
                      }}</span> day{{ weeklyPaGoalDays !== 1 ? 's' : '' }}
                      of at least <span class="text-palo-verde text-[2rem]">
                        {{ weeklyPaGoal != null ? (weeklyPaGoal | number:'1.0':'en-US') : '_' }}
                      </span> activity points.
                    </div>
                    <div>
                      You've reached this goal <span class="text-palo-verde text-[2rem]">{{
                        weeklyPaGoalMetDays === null ? '_' : weeklyPaGoalMetDays }}</span> day{{
                        weeklyPaGoalMetDays !== 1 ? 's' : '' }} this week.
                    </div>
                    <!--                  <div *ngIf="selectedUserRole === 4 || role === 4">-->
                    <!--                    Activity Points: <span class="text-palo-verde text-[2rem]">{{ weeklyPaPointSum || '_' }}</span>-->
                    <!--                  </div>-->
                  </ng-container>
                </ng-container>
              </div>
              <span
                (click)="viewProgress('pa')"
                class="view-progress underline
              text-[1.4rem] font-work-sans
              font-normal text-digital-blue-light
              cursor-pointer mt-[2.4rem]"
              >
        View Progress
      </span>
            </div>
            <div
              *ngIf="showDetailsForAdult || (weekSummary['lastSessionInWeek']
               >= 15 && selectedDateDetails['lastSession'] >= 15)"
              class="chart-container flex
                 flex-col justify-center items-center"
            >
              <div
                class="heading flex flex-row
              justify-center items-center
              space-x-[1rem]"
              >
                <app-icon
                  class="screen-time-icon"
                  svgIcon="screen-time"
                >
                </app-icon>
                <span class="font-bold font-poppins text-[2rem] text-cool-grey">My Screen Time</span>
                <app-icon
                  [matTooltip]="'Lighter colored bars are estimated using the highest value from that week.'"
                  class="info-icon ml-[1rem]"
                  matTooltipClass="custom-tooltip"
                  matTooltipPosition="above"
                  svgIcon="info"
                />
              </div>
              <app-screen-time-chart
                [data]="weekSummary['weekData']"
                class="screen-time-chart w-full"
              >
              </app-screen-time-chart>
              <div
                class="font-semibold font-work-sans text-[1.5rem] text-cool-grey flex flex-col justify-center items-center mt-[3.2rem]"
              >
                <ng-container
                  *ngIf="(weekSummary['lastSessionInWeek'] >= 17 && selectedDateDetails['lastSession'] >= 17)"
                >
                  <div *ngIf="!showDetailsForAdult">
                    Weekly goal: <span class="text-palo-verde text-[2rem]">{{ (weeklyStGoal|hrAndMin) || '_' }}</span>
                    or
                    less,
                  </div>
                </ng-container>
                <div>
                  You used <span class="text-palo-verde text-[2rem]"> {{
                    weeklyStPointSum !== null ? (weeklyStPointSum|hrAndMin) : '_' }}</span> this week
                </div>
              </div>
              <span
                (click)="viewProgress('st')"
                class="view-progress underline
                        text-[1.4rem] font-work-sans
                        font-normal text-digital-blue-light
                        cursor-pointer mt-[2.4rem]"
              >
        View Progress
      </span>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
      <hr
        *ngIf="showDetailsForAdult || weekSummary['lastSessionInWeek'] >= 2"
        class="hr"
      >
      <div
        *ngIf="showDetailsForAdult || weekSummary['lastSessionInWeek'] >= 2"
        class="daily-total-section"
      >
        <mat-expansion-panel
          [expanded]="true"
          class="mat-elevation-z0 expansion-panel w-full"
        >
          <mat-expansion-panel-header class="flex flex-row justify-center items-center">
            <div class="title flex flex-row justify-center items-center gap-[1rem]">
              <span>My Daily Total</span>
              <app-icon
                [matTooltip]="'Type in your behavior tracker \n\n totals from your paper journal \n\n or use your e-journal.'"
                class="info-icon"
                matTooltipClass="custom-tooltip"
                matTooltipPosition="above"
                svgIcon="info"
              ></app-icon>
            </div>
          </mat-expansion-panel-header>
          <div
            class="flex flex-col justify-start items-center gap-[2.4rem] my-[2.4rem] bg-transparent"
          >
            <app-day-selector
              [data]="weekSummary['weekData']"
              class="w-full"
            />
            <app-daily-score-panel
              [showDetailsForAdult]="showDetailsForAdult"
              class="w-full"
            />
          </div>
        </mat-expansion-panel>
      </div>
      <div class="resource-section">
        <mat-expansion-panel
          [expanded]="true"
          class="mat-elevation-z0 expansion-panel w-full"
        >
          <mat-expansion-panel-header class="flex flex-row justify-center items-center">
            <div class="title">
              My Resources
            </div>
          </mat-expansion-panel-header>
          <div
            *ngIf="!resourcesData.loading || paginationRelatedLoading"
            class="my-resource-panel grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4"
          >
            <div
              *ngFor="let resource of myResources;let index=index"
              class="flex justify-center w-full"
            >
              <app-resource-card
                [resource]="resource"
                class="w-full"
              ></app-resource-card>

            </div>
          </div>
          <ng-template #noData>
            <div class="no-data flex flex-col justify-center">
              No Data Available
            </div>
          </ng-template>
          <div
            *ngIf="resourcesData.loading && paginationRelatedLoading"
            class="flex justify-center items-center pagination-loading"
          >
            <mat-spinner
              [diameter]="30"
              mode="indeterminate"
              strokeWidth="4"
            />
          </div>
          <div
            *ngIf="resourcesData.loading && !paginationRelatedLoading"
            class="flex justify-center items-center loading-wrapper"
          >
            <mat-spinner
              [diameter]="100"
              mode="indeterminate"
              strokeWidth="5"
            />
          </div>
        </mat-expansion-panel>
      </div>
      <hr class="hr">
    </div>
  </ng-template>

</div>
